<script lang="ts">
  import { Button, Container, Input, Label, Row } from "sveltestrap";
  import { Copytext } from "../../../utils/Constant/Constant";
  import FeatherIcon from 'svelte-feather-icon';
  import {iTag,icons,iconClick} from "../../../store"
    function handleClose(){
        iconClick.update(value => value = false);
    }
    let setItag:string
    iTag.subscribe((value) => {
        setItag = value
    })
    let setIcons:string
    icons.subscribe((value)=>{
        setIcons = value
    })
    let setIconClick:boolean
    iconClick.subscribe((value)=>{
        setIconClick = value
    })
</script>
<div class="icon-hover-bottom p-fixed fa-fa-icon-show-div {setIconClick ? "d-block" :"opecity-0"}" >
    <Container fluid>
      <Row>
        <div class="icon-popup">
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="close-icon" on:click={handleClose}><i class="icofont icofont-close"></i></div>
          <div class="icon-first"><FeatherIcon icon={setIcons} /></div>
          <div class="icon-class">
            <Label class="icon-title">Class</Label>
            <span id="fclass1">{setIcons}</span>
          </div>
          <div class="icon-last icon-last">
            <Label class="icon-title">Markup</Label>
            <div class="form-inline">
              <div class="form-group">
                <Input class="inp-val m-r-10" id="input_copy" type="text" bind:value={setItag} readonly />
                <Button color="primary" class="notification">{Copytext}</Button>
              </div>
            </div>
          </div>
        </div>
      </Row>
    </Container>
</div>